import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import useScript from '@charlietango/use-script'
import { ApiKeys } from '@lib/variables'
import { Error, Field, FieldLabel } from '../Field/Field.styled'
import Input from '../Input'
import * as S from './GooglePlaceAutoComplete.styled'

const GooglePlaceAutoComplete = (props) => {
  const [ready] = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${ApiKeys.GOOGLE_MAP_KEY}&libraries=places`
  )
  const {
    onChange,
    onSelect,
    className,
    placeholder,
    value,
    required,
    error,
    helpText,
  } = props

  const handleChange = (address) => {
    if (onChange && typeof onChange == 'function') {
      onChange(address)
    }
  }

  const handleSelect = (address) => {
    if (onChange && typeof onChange == 'function') {
      onChange(address)
    }
    let is_valid_address = false
    geocodeByAddress(address)
      .then((results) => {
        for (let component in results[0].address_components) {
          if (
            results[0].address_components[component]['types'].includes('route')
          ) {
            is_valid_address = true
          }
        }

        if (is_valid_address == false) {
          results[0] = results[1]
        }

        getLatLng(results[0]).then((location) => {
          if (onSelect && typeof onSelect == 'function') {
            onSelect(address, results[0], location)
          }
        })
      })
      .then((latLng) => console.log('Success', latLng))
      .catch((error) => console.error('Error', error))
  }

  if (!ready) return null

  return (
    <PlacesAutocomplete
      value={value}
      onChange={handleChange}
      onSelect={handleSelect}
      searchOptions={{
        types: ['address'],
        componentRestrictions: { country: 'au' },
      }}
      debounce={200}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Field error={error}>
          <FieldLabel>{placeholder}</FieldLabel>
          <S.AutoCompleteInput isOpen={suggestions.length}>
            <Input
              {...getInputProps({
                label: 'Search Places ...',
                className:
                  (className || 'location-search-input') +
                  (error ? ' is-invalid' : ''),
                required: required,
              })}
            />
            {suggestions?.length > 0 && (
              <S.GooglePlaceAutoCompleteResults>
                {suggestions.map((suggestion, key) => {
                  const className = suggestion.active ? 'active' : ''
                  return (
                    <S.AutAutoCompleteItem
                      {...getSuggestionItemProps(suggestion, {
                        className,
                      })}
                      key={`suggestion-${key}`}
                    >
                      <span>{suggestion.description}</span>
                    </S.AutAutoCompleteItem>
                  )
                })}
              </S.GooglePlaceAutoCompleteResults>
            )}
          </S.AutoCompleteInput>
          {error && <Error>{error}</Error>}
          {helpText && <S.HelpText>{helpText}</S.HelpText>}
        </Field>
      )}
    </PlacesAutocomplete>
  )
}

export default GooglePlaceAutoComplete
